(function (factory) {
  /* global define */
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // Node/CommonJS
    module.exports = factory(require('jquery'));
  } else {
    // Browser globals
    factory(window.jQuery);
  }
}(function ($)
{
	$.extend($.summernote.plugins,
	{
		documentbrowser: function (context)
		{
			var self = $(this),
				  ui = $.summernote.ui;

			// add hello button
			context.memo('button.documentbrowser', function()
			{
				// create button
				var button = ui.button({
					contents: '<i class="fa fa-file-text-o"/>',
					tooltip: 'Document',
					click: function ()
					{
						context.invoke('editor.saveRange');

						$.fancybox( 
						{
							width: '95%',
							autoSize: false,
							autoWidth: false,
							autoHeight: true,
							padding: 0,
							wrapCSS: 'fancybox-documentbrowser',
							type: 'ajax',
							href: '/api/documentbrowser',
							helpers: {
								overlay: {
									locked: false
								}
							},
							afterShow: function()
							{
								var $inner = $(this.inner);

								var dataTable = $inner.find('table').DataTable({
									dom: "<'search'f>t<'nav'p>",
									info: false,
									language: {
										search: '',
										searchPlaceholder: 'Type om te zoeken..'
									},
									lengthChange: false,
									pageLength: 25,
									searching: true,
									order: [[ 1, 'asc' ]]
								});

								$inner.find('table tbody td').on('click', function(e)
								{
									e.preventDefault();

									$(this).closest('tr').find('input[type="checkbox"]').prop('checked', !$(this).closest('tr').find('input[type="checkbox"]').prop('checked'));
								});

								$inner.find('.submit').on('click', function(e)
								{
									e.preventDefault();

									var documents = [];
									$(':input[type="checkbox"]:checked', dataTable.rows().nodes()).each(function()
									{
										documents.push($(this).val());
									});

									context.invoke('editor.restoreRange');
									context.invoke('editor.focus');
									context.invoke('editor.insertText', "[documents search='0' ids='" + documents.join(',') + "']");

									$.fancybox.close();
								});
							}
						});
					}
				});

				return button.render();
			});
		}
	});
}));